import AppRoutes from "routes";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "translations";
import AppContextProvider from "context/AppContext ";

function App() {
  return (
    <div>
      <I18nextProvider i18n={i18n} defaultNS={"translation"}>
        <AppContextProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AppContextProvider>
      </I18nextProvider>
    </div>
  );
}

export default App;
